(function ($) {
    $(document).ready(function () {

        doctorFinder();
        doctorSelect();
    });

    function doctorFinder() {

        var locationSelect  = document.querySelector('.c-doctor_select--location'),
            treatmentSelect = document.querySelector('.c-doctor_select--treatment'),
            typeSelect      = document.querySelector('.c-doctor_select--type'),
            doctorContainer = $('.c-doctor_article'),
            doctorNone      = $('.c-doctor_none'),
            selectAll       = $('.c-doctor_select'),
            typeTitle       = $('.c-doctor_type-title');

        if( locationSelect != null ) {

            locationSelect.onchange = function() {
                var locationSelected = locationSelect.options[locationSelect.selectedIndex].value;

                if( locationSelected != 'All' ) {
                    typeTitle.hide();
                } else {
                    typeTitle.show();
                }
    
                doctorContainer.each(function () {
    
                    $(this).removeClass('location-hide');
    
                    if ( !$(this).data('locations').includes(locationSelected) && locationSelected !== 'All' ) {
                        $(this).addClass('location-hide');
                    }
                });
            }
        }

        if( treatmentSelect != null) {

            treatmentSelect.onchange = function() {
                var treatmentSelected = treatmentSelect.options[treatmentSelect.selectedIndex].value;
    
                doctorContainer.each(function () {
    
                    $(this).removeClass('treatment-hide');
    
                    if (!$(this).data('treatments').includes(treatmentSelected) && treatmentSelected !== 'All') {
                        $(this).addClass('treatment-hide');
                    }
                });
            }
        }

        if ( typeSelect != null ) {

            typeSelect.onchange = function () {
                var typeSelected = typeSelect.options[typeSelect.selectedIndex].value;

                if( typeSelected != 'All' ) {
                    typeTitle.hide();
                } else {
                    typeTitle.show();
                }

                doctorContainer.each(function () {

                    $(this).removeClass('type-hide');

                    if (!$(this).data('types').includes(typeSelected) && typeSelected !== 'All') {
                        $(this).addClass('type-hide');
                    }
                });
            }
        }

        selectAll.change(function () {
            doctorContainer.each(function () {

                if (!$(this).is(':hidden')) {
                    doctorNone.hide();
                    return false;
                } else {
                    doctorNone.show();
                }
            });
        });
    }

    function doctorSelect() {

        var doctorSelect = document.querySelector('.c-doctor_select--doctor');

        if( doctorSelect != null ) {

            doctorSelect.onchange = function() {
                var doctorSelected = doctorSelect.options[doctorSelect.selectedIndex].value;
                window.location.href = doctorSelected;
            }
        }
    }
})(jQuery);